// extracted by mini-css-extract-plugin
export default {"root":"ToBeResumedTableHeader_root__ntlge","heading":"ToBeResumedTableHeader_heading__Y9O9H"};